import { render, staticRenderFns } from "./HostingVServerPassword.vue?vue&type=template&id=38b5d828&"
import script from "./HostingVServerPassword.vue?vue&type=script&lang=js&"
export * from "./HostingVServerPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b5d828')) {
      api.createRecord('38b5d828', component.options)
    } else {
      api.reload('38b5d828', component.options)
    }
    module.hot.accept("./HostingVServerPassword.vue?vue&type=template&id=38b5d828&", function () {
      api.rerender('38b5d828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/HostingVServerPassword.vue"
export default component.exports